export const granteeTabs = {
  REGISTER: 0,
  SELECT: 1
};
